<template lang="pug">
  div
    header-without-menu
    b-container.content.page-container
      b-row.header
        img(src="../../../assets/logo_big.png")
      b-row.title
        div 이메일 초대 일회성 원격
      div.horizontal-line.mt-4
      b-row
        b-col.mt-4(cols="12")
          div.input-container
            span *
            span 이메일 초대 원격 코드 입력 :
            b-input-group
              b-form-input(v-model="inputValue", type="text", placeholder="코드 입력")
              b-input-group-append
                b-button(variant="primary", @click="handleButtonClick") 확인
      div.horizontal-line
      b-row.footer
        div.centered-content
          span COPYRIGHT 20232. KOINO Inc. all rights reserved.

</template>

<script>
import { HeaderWithoutMenu } from '../../mixins/header'

export default {
  name: 'email-invitation',
  components: {HeaderWithoutMenu},
  methods: {
    handleButtonClick() {
      // 클릭 이벤트 처리 로직을 여기에 작성하세요
      if (this.inputValue === null) {
        return this.$awn.alert('원격 코드를 입력해 주세요.')
      }
    },
  },
  data() {
    return {
      inputValue: null,
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  padding-top: 7rem;
}

.header {
  justify-content: center;
  margin-bottom: 2rem;
  > img {
    width: 17rem;
  }
}

.title {
  justify-content: center;
  margin: 3rem 0 0 0;
  > div {
    font-size: 2rem;
    font-weight: 550;
    letter-spacing: 1px;
  }
}

.input-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8rem 0;
  > span {
    font-size: 1.1rem;
  }
  > .input-group {
    margin-left: 1rem;
    width: 40%;
  }
}

.horizontal-line {
  width: 70%;
  height: 3px;
  background-color: #7d7d7d;
  margin: 0 auto;
}

.centered-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer {
  justify-content: center;
  margin-top: 1.5rem;
  span {
    font-size: 0.9rem;
    font-weight: 350;
    letter-spacing: 2px;
  }
}
</style>
